import * as React from 'react';
import styled from '@emotion/styled';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import StyledToolTips from '../../../../../../../utils/tooltip/StyledToolTip';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-content: center;
  margin: 0.3rem 0;
`;

const StyledIconDiv = styled.div`
  margin: 5px 50px auto 5px;
`;
const StyledWeekDays = styled.td`
  padding-left: 0;
`;
const StyledWorkingHours = styled.td`
  padding: 0 15px;
`;

interface OperationHoursProps {
  operationHours: Map<TargetObj, fhir4.LocationHoursOfOperation> | undefined;
}

const targetObj = Object.freeze({
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
  sun: 'Sunday',
} as const);

type TargetObj = keyof typeof targetObj;

const OperationHours = ({ operationHours }: OperationHoursProps) => {
  return (
    <StyledContainer>
      <StyledIconDiv>
        <StyledToolTips title="Operating Hours" enterDelay={100} arrow>
          <AccessTimeFilledIcon color="disabled" />
        </StyledToolTips>
      </StyledIconDiv>
      <table>
        <tbody>
          {Object.entries(targetObj)?.map(([key, value]) => {
            const { openingTime = '', closingTime = '' } = operationHours?.get(key as TargetObj) ?? {};
            return (
              <tr key={key}>
                <StyledWeekDays>
                  <div>{value}</div>
                </StyledWeekDays>
                <StyledWorkingHours>
                  {`${openingTime}` === 'Open 24 hours' || `${openingTime}` === 'Closed' ? `${openingTime}` : `${openingTime} - ${closingTime}`}
                </StyledWorkingHours>
              </tr>
            );
          })}
        </tbody>
      </table>
    </StyledContainer>
  );
};

export default OperationHours;
